<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Manage Clients</h5>
  </div>
<div id="mainContent" class="container">
  <div id="clientTable" class="pt-4 pb-4">
    <div class="row">
      <div class="col-md-6 offset-md-1">
        <div class="row">
          <div class="col-md-8">
            <form (submit)="searchClientsByName()" action="#">
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control form-control-xs"
                  [(ngModel)]="query"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Search Client"
                  aria-label="Search Employee"
                  aria-describedby="button-addon2"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-theme btn-xs"
                    type="submit"
                    id="button-addon2"
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-5">
                <button
                  mat-raised-button
                  class="btn-theme"
                  matTooltip="Click to add client"
                  matTooltipPosition="left"
                  (click)="openModal('add')"
                >
                  <i class="fa fa-plus-square" aria-hidden="true"></i
                  >&nbsp;&nbsp; Client
                </button>
              </div>
              <div class="col-md-7">
                <button
                  mat-raised-button
                  class="btn-theme"
                  (click)="exportToExcelReport()"
                >
                  Export To Excel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-md-10 offset-md-1">
        <table class="table table-sm table-bordered table-striped">
          <thead class="">
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Name</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let formObj of formObjList | search: 'name':query;
                index as i
              "
              id="client_{{ i + 1 }}"
            >
              <td scope="row">{{ i + 1 }}</td>
              <td>{{ formObj.name }}</td>
              <td>
                <button
                  class="btn btn-sm btn-outline-theme"
                  (click)="onEditClick(formObj)"
                  matTooltip="Click to edit"
                  matTooltipPosition="above"
                >
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </button>
                &nbsp;&nbsp;

                <button
                  class="btn btn-sm btn-outline-danger"
                  (click)="onDeleteClick(formObj)"
                  matTooltip="Click to delete"
                  matTooltipPosition="above"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2 offset-md-1">
        <button
          id="prevBtn"
          name="prevBtn"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="loadPreviousClients()"
          [disabled]="page == 0"
          matTooltip="Click to load previous users"
          matTooltipPosition="above"
        >
          <i class="fa fa-arrow-left" aria-hidden="true"></i> Previous
        </button>
      </div>
      <div
        class="col-md-6 text-muted"
        style="text-align: center; font-weight: bold"
      >
        <span
          >Showing records for Page : {{ page + 1 }} , Records :
          {{ formObjList.length }}</span
        >
      </div>
      <div class="col-md-2">
        <button
          id="nextBtn"
          name="nextBtn"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="loadNextClients()"
          matTooltip="Click to load next users"
          matTooltipPosition="above"
        >
          Next <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>
</div>

<!-- class="col-md-10 offset-md-1" -->

<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">Client</h5>
  </div>
  <div class="modal-body">
    <div
      id="clientForm"
      style="padding: 0%"
      class=""
      *ngIf="formStatus == 'add' || formStatus == 'edit'"
    >
      <!-- <mat-card> -->
      <form [formGroup]="formObj">
        <div id="clientInfoDiv" *ngIf="!showChecklist && !showClientBudget">
          <div class="row col-md-12">
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Name :</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="name"
                  [class.is-invalid]="formErrors.name && formSubmitted"
                  matTooltip="{{ formErrors.name }}"
                  matTooltipPosition="above"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Email :  
                  <!-- <input
                    id="multipleEmails"
                    name="multipleEmails"
                    type="checkbox"
                    class="form-check-input"
                    (change)="onMultipleEmailsChange($event)"
                    style="margin-left: 2px;"
                  />
                  <span style="margin-left: 20px;">(multiple emails)</span> -->
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  class="form-control form-control-xs"
                  formControlName="email"
                  [class.is-invalid]="formErrors.email && formSubmitted"
                  matTooltip="{{ formErrors.email }}"
                  matTooltipPosition="above"
                />
                <div class="form-check">
                  
                  <!-- <label for="multipleEmails" class="form-check-label ms-1">Multiple Emails</label> -->
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">PAN :</label>
                <input
                  id="pan"
                  name="pan"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="pan"
                  [class.is-invalid]="formErrors.pan && formSubmitted"
                  matTooltip="{{ formErrors.pan }}"
                  matTooltipPosition="above"
                />
              </div>
            </div>
          </div>
        <!-- additional email -->
<div formArrayName="clientEmails">
  <div class="row col-md-12">
    <div
      *ngFor="let emailGroup of formObj.get('clientEmails').controls; let i = index"
      [formGroupName]="i"
      class="col-md-4"
    >
      <div class="form-group mb-0">
        <label class="mb-0">Additional Email {{ i + 1 }}:</label>
        <input
          type="email"
          class="form-control form-control-xs"
          [id]="'id_' + i"
          [name]="'id_' + i"
          formControlName="email"
          matTooltip="{{ formErrors.id }}"
          matTooltipPosition="above"
          placeholder="Enter email"
        />
      </div>
    </div>
  </div>
</div>


          <div class="row col-md-12">
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">State :</label>
                <select
                  class="form-control form-control-xs"
                  id="state"
                  name="state"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="state"
                  (change)="loadCities(formObj.get('state').value)"
                  [class.is-invalid]="formErrors.state && formSubmitted"
                  matTooltip="{{ formErrors.state }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option *ngFor="let state of stateList" [ngValue]="state">
                    {{ state.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">City :</label>
                <select
                  *ngIf="formStatus == 'add'"
                  class="form-control form-control-xs"
                  id="city"
                  name="city"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="city"
                  (change)="loadPostcode(formObj.get('city').value)"
                  [class.is-invalid]="formErrors.city && formSubmitted"
                  matTooltip="{{ formErrors.city }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option *ngFor="let city of clientCityList" [ngValue]="city">
                    {{ city.name }}
                  </option>
                </select>
                <div
                  *ngIf="formStatus == 'edit' && !showClientCity"
                  (click)="enableClientCity()"
                  matTooltip="'Click To Change'"
                  matTooltipPosition="above"
                  style="cursor: pointer"
                >
                  <span *ngIf="formObj.value.city">{{
                    formObj.value.city.name
                  }}</span>
                </div>

                <select
                  *ngIf="formStatus == 'edit' && showClientCity"
                  class="form-control form-control-xs"
                  id="city"
                  name="city"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="city"
                  (change)="enableClientPostCode()"
                  [class.is-invalid]="formErrors.city && formSubmitted"
                  matTooltip="{{ formErrors.city }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option *ngFor="let city of clientCityList" [ngValue]="city">
                    {{ city.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Postcode :</label>
                <select
                  *ngIf="formStatus == 'add'"
                  class="form-control form-control-xs"
                  id="postCode"
                  name="postCode"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="postCode"
                  [class.is-invalid]="formErrors.postCode && formSubmitted"
                  matTooltip="{{ formErrors.postCode }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option
                    *ngFor="let postCode of clientPostcodeList"
                    [ngValue]="postCode"
                  >
                    {{ postCode.name }}
                  </option>
                </select>
                <div
                  *ngIf="formStatus == 'edit' && !showClientPostCode"
                  (click)="enableClientPostCode()"
                  matTooltip="'Click To Change'"
                  matTooltipPosition="above"
                  style="cursor: pointer"
                >
                  <span *ngIf="formObj.value.postCode">{{
                    formObj.value.postCode.name
                  }}</span>
                </div>
                <select
                  *ngIf="formStatus == 'edit' && showClientPostCode"
                  class="form-control form-control-xs"
                  id="postCode"
                  name="postCode"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="postCode"
                  [class.is-invalid]="formErrors.postCode && formSubmitted"
                  matTooltip="{{ formErrors.postCode }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option
                    *ngFor="let postCode of clientPostcodeList"
                    [ngValue]="postCode"
                  >
                    {{ postCode.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-12">
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Address :</label>
                <textarea
                  style="overflow: auto; resize: none"
                  rows="1"
                  cols="20"
                  id="address"
                  name="address"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="address"
                  [class.is-invalid]="formErrors.address && formSubmitted"
                  matTooltip="{{ formErrors.address }}"
                  matTooltipPosition="above"
                >
                </textarea>
              </div>
            </div>
            <!-- <div class="col-md-4">
            <div class="form-group mb-0">
              <label class="mb-0">Alias :</label>
              <input id="alias" name="alias" type="text" class="form-control form-control-xs"
              formControlName="alias"
              [class.is-invalid]="formErrors.alias && formSubmitted" matTooltip="{{formErrors.alias}}" matTooltipPosition="above">
            </div>
          </div> -->
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">GST Number :</label>
                <input
                  id="gstNumber"
                  name="gstNumber"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="gstNumber"
                  [class.is-invalid]="formErrors.gstNumber && formSubmitted"
                  matTooltip="{{ formErrors.gstNumber }}"
                  matTooltipPosition="above"
                  (blur)="checkGSTValidation()"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Chargeable To Client :</label>
                <select
                  class="form-control form-control-xs"
                  id="chargeableToClient"
                  name="chargeableToClient"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="chargeableToClient"
                  [class.is-invalid]="
                    formErrors.chargeableToClient && formSubmitted
                  "
                  matTooltip="{{ formErrors.chargeableToClient }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option
                    *ngFor="let chargable of chargableToClientList"
                    [ngValue]="chargable.value"
                  >
                    {{ chargable.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-12">
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Legal Status :</label>
                <select
                  class="form-control form-control-xs"
                  id="legalStatus"
                  name="legalStatus"
                  formControlName="legalStatus"
                  [class.is-invalid]="formErrors.legalStatus && formSubmitted"
                  matTooltip="{{ formErrors.legalStatus }}"
                  matTooltipPosition="above"
                  (change)="onLegalStatusChange()"
                >
                  <option [value]="null">Select</option>
                  <option
                    *ngFor="let legalStatus of legalStatusList"
                    [ngValue]="legalStatus"
                  >
                    {{ legalStatus.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Branch :</label>
                <select
                  class="form-control form-control-xs"
                  id="branch"
                  name="branch"
                  formControlName="branch"
                  [class.is-invalid]="formErrors.branch && formSubmitted"
                  matTooltip="{{ formErrors.branch }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option *ngFor="let branch of branchList" [ngValue]="branch">
                    {{ branch.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Sector :</label>
                <select
                  class="form-control form-control-xs"
                  id="sector"
                  name="sector"
                  formControlName="sector"
                  [class.is-invalid]="formErrors.sector && formSubmitted"
                  matTooltip="{{ formErrors.sector }}"
                  matTooltipPosition="above"
                >
                  <option [value]="null">Select</option>
                  <option *ngFor="let sector of sectorList" [ngValue]="sector">
                    {{ sector.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-12">
            <!-- <div class="col-md-4">
            <div class="form-group mb-0">
              <label class="mb-0">Principal Place Of Business :</label>
              <textarea style="overflow:auto;resize:none" rows="1" cols="20" id="principalPlaceOfBusiness" name="principalPlaceOfBusiness" type="text"
              class="form-control form-control-xs" formControlName="principalPlaceOfBusiness"
              [class.is-invalid]="formErrors.principalPlaceOfBusiness && formSubmitted" matTooltip="{{formErrors.principalPlaceOfBusiness}}" matTooltipPosition="above"></textarea>
            </div>
          </div> -->
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">Ediary Status :</label>
                <select
                  class="form-control form-control-xs"
                  id="ediaryStatus"
                  name="ediaryStatus"
                  formControlName="ediaryStatus"
                  [class.is-invalid]="formErrors.ediaryStatus && formSubmitted"
                  matTooltip="{{ formErrors.ediaryStatus }}"
                  matTooltipPosition="above"
                >
                  <option [ngValue]="null">Select</option>
                  <option
                    *ngFor="let ediaryStatusObj of ediaryStatusList"
                    [ngValue]="ediaryStatusObj"
                  >
                    {{ ediaryStatusObj.name }}
                  </option>
                </select>
              </div>
            </div>
            <div *ngIf="cinActiveFlag" class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">CIN :</label>
                <input
                  id="cinNumber"
                  name="cinNumber"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="cinNumber"
                  [class.is-invalid]="formErrors.cinNumber && formSubmitted"
                  matTooltip="{{ formErrors.cinNumber }}"
                  matTooltipPosition="above"
                />
              </div>
              <!-- <div *ngIf="getErrorMessage(formObj.get('cinNumber')) !== ''">
                {{ getErrorMessage(formObj.get('cinNumber')) }}
              </div> -->
            </div>
            <div *ngIf="llpinActiveFlag"  class="col-md-4">
              <div class="form-group mb-0">
                <label class="mb-0">LLPIN :</label>
                <input
                  id="llpinNumber"
                  name="llpinNumber"
                  type="text"
                  class="form-control form-control-xs"
                  formControlName="llpinNumber"
                  [class.is-invalid]="formErrors.llpinNumber && formSubmitted"
                  matTooltip="{{ formErrors.llpinNumber }}"
                  matTooltipPosition="above"
                />
              </div>
            </div>
          </div>

          <div class="row col-md-12">
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
          </div>

          <hr style="margin: 1% 1%" />
          <div class="row col-md-12 mt-2">
            <div class="col-md-4">
              <button
                type="button"
                class="btn btn-xs btn-theme"
                (click)="addPartnerButtonClick()"
              >
                <i class="fa fa-plus-square-o" aria-hidden="true"></i> Partner
              </button>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
          </div>
          <hr style="margin: 1% 1%" />
          <div id="location-container">
            <div
              formArrayName="partners"
              *ngFor="
                let partner of formObj.get('partners').controls;
                let i = index;
                let first = first
              "
            >
              <div class="row col-md-12" [formGroupName]="i">
                <div class="col-md-3">
                  <div class="form-group mb-0">
                    <label class="mb-0">Partner :</label>
                    <select
                      class="form-control form-control-xs"
                      [id]="'id_' + i"
                      [name]="'id_' + i"
                      formControlName="id"
                      [class.is-invalid]="
                        partner.get('id').errors?.required && formSubmitted
                      "
                      matTooltip="{{ formErrors.id }}"
                      matTooltipPosition="above"
                      (change)="onPartnerChange(i)"
                    >
                      <!-- (change)="onPartnerChange(i)" -->
                      <option value="">Select</option>
                      <option
                        *ngFor="let partner of partnerList"
                        [ngValue]="partner.id"
                      >
                        {{ partner.firstName }} {{ partner.middleName }}
                        {{ partner.lastName }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group mb-0">
                    <!-- <label class="mb-0">Assignments :</label> (selectionChange)="onAssignmentChange($event)" -->
                    <mat-form-field appearance="legacy" style="width: 300px">
                      <mat-label>Assignments</mat-label>
                      <mat-select
                        formControlName="assignments"
                        multiple
                        [compareWith]="compareItems"
                        [(ngModel)]="partner.get('assignments').value"
                        (blur)="changesInAssignments()"
                        [disabled]="
                          formObj.get('partners').controls[i].value.toDate == ''
                        "
                      >
                        <mat-option
                          #item
                          *ngFor="let assignment of assignmentList"
                          [value]="assignment"
                          [disabled]="assignment.disabled"
                          (click)="
                            onAssignmentChange(
                              formObj.get('partners').controls[i],
                              assignment,
                              i,item
                            )
                          "
                        >
                          {{ assignment.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <span
                      *ngIf="
                        partner.get('assignments').errors?.incorrect &&
                        formSubmitted
                      "
                      class="text-danger"
                      >* comman assignments for same time period</span
                    >
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group mb-0">
                    <label for="fromDate" class="mb-0">From Date :</label>
                    <div class="input-group">
                      <input
                        class="form-control form-control-xs"
                        placeholder="dd/mm/yyyy"
                        name="fromDate"
                        formControlName="fromDate"
                        ngbDatepicker
                        #fromDate="ngbDatepicker"
                        [class.is-invalid]="
                          partner.get('fromDate').errors?.required &&
                          formSubmitted
                        "
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-theme calendar"
                          (click)="fromDate.toggle()"
                          type="button"
                        ></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group mb-0">
                    <label for="toDate" class="mb-0">To Date :</label>
                    <div class="input-group">
                      <input
                        class="form-control form-control-xs"
                        placeholder="dd/mm/yyyy"
                        name="toDate"
                        formControlName="toDate"
                        ngbDatepicker
                        #toDate="ngbDatepicker"
                        [minDate]="partner.get('fromDate').value"
                        (dateSelect)="onToDateChange(i)"
                        [class.is-invalid]="
                          partner.get('toDate').errors?.required &&
                          formSubmitted
                        "
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-theme calendar"
                          (click)="toDate.toggle()"
                          type="button"
                        ></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1">
                  <button
                    type="button"
                    *ngIf="!first"
                    class="btn btn-sm btn-outline-danger mt-3"
                    (click)="removePartnerButtonClick(formObj.get('partners').controls[i],i,formObj.value)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr style="margin: 1% 1%" />
          <div class="row col-md-12 mt-2">
            <div class="col-md-4">
              <button
                type="button"
                class="btn btn-xs btn-theme"
                (click)="addLocationButtonClick()"
              >
                <i class="fa fa-plus-square-o" aria-hidden="true"></i> Location
              </button>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-3"></div>
            <div class="col-md-1"></div>
          </div>
          <hr style="margin: 1% 1%" />
          <div id="location-container">
            <div
              formArrayName="clientLocations"
              *ngFor="
                let location of formObj.get('clientLocations').controls;
                let i = index;
                let first = first
              "
            >
              <div class="row col-md-12" [formGroupName]="i">
                <div class="col-md-3">
                  <div class="form-group mb-0">
                    <label class="mb-0">Address :</label>
                    <textarea
                      style="overflow: auto; resize: none"
                      rows="1"
                      cols="20"
                      [id]="'address_' + i"
                      [name]="'address_' + i"
                      type="text"
                      class="form-control form-control-xs"
                      formControlName="address"
                      [class.is-invalid]="
                        location.get('address').errors?.required &&
                        formSubmitted
                      "
                      matTooltip="{{ formErrors.address }}"
                      matTooltipPosition="above"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group mb-0">
                    <label class="mb-0">State :</label>
                    <select
                      class="form-control form-control-xs"
                      [id]="'state_' + i"
                      [name]="'state_' + i"
                      type="text"
                      class="form-control form-control-xs"
                      formControlName="state"
                      (change)="
                        loadCitiesForLocation(location.get('state').value, i)
                      "
                      [class.is-invalid]="
                        location.get('state').errors?.required && formSubmitted
                      "
                      matTooltip="{{ formErrors.state }}"
                      matTooltipPosition="above"
                    >
                      <option [value]="null">Select</option>
                      <option *ngFor="let state of stateList" [ngValue]="state">
                        {{ state.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group mb-0">
                    <label class="mb-0">City :</label>
                    <select
                      *ngIf="formStatus == 'add'"
                      class="form-control form-control-xs"
                      [id]="'city_' + i"
                      [name]="'city_' + i"
                      type="text"
                      class="form-control form-control-xs"
                      formControlName="city"
                      (change)="
                        loadPostcodeForLocation(location.get('city').value, i)
                      "
                      [class.is-invalid]="
                        location.get('city').errors?.required && formSubmitted
                      "
                      matTooltip="{{ formErrors.city }}"
                      matTooltipPosition="above"
                    >
                      <option [value]="null">Select</option>
                      <option
                        *ngFor="let city of locationCityList[i]"
                        [ngValue]="city"
                      >
                        {{ city.name }}
                      </option>
                    </select>

                    <div
                      *ngIf="formStatus == 'edit' && !locationCityListEnable[i]"
                      (click)="
                        enableLocationCity(location.get('state').value, i)
                      "
                      matTooltip="Click To Change"
                      matTooltipPosition="above"
                      style="cursor: pointer"
                    >
                      <span *ngIf="location.get('city').value">{{
                        location.get("city").value.name
                      }}</span>
                    </div>

                    <select
                      *ngIf="formStatus == 'edit' && locationCityListEnable[i]"
                      class="form-control form-control-xs"
                      [id]="'city_' + i"
                      [name]="'city_' + i"
                      type="text"
                      class="form-control form-control-xs"
                      formControlName="city"
                      (change)="
                        enableLocationPostCode(location.get('city').value, i)
                      "
                      [class.is-invalid]="
                        location.get('city').errors?.required && formSubmitted
                      "
                      matTooltip="{{ formErrors.city }}"
                      matTooltipPosition="above"
                    >
                      <option [value]="null">Select</option>
                      <option
                        *ngFor="let city of locationCityList[i]"
                        [ngValue]="city"
                      >
                        {{ city.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group mb-0">
                    <label class="mb-0">Postcode :</label>
                    <select
                      *ngIf="formStatus == 'add'"
                      class="form-control form-control-xs"
                      [id]="'postCode_' + i"
                      [name]="'postCode_' + i"
                      type="text"
                      class="form-control form-control-xs"
                      formControlName="postCode"
                      [class.is-invalid]="
                        location.get('postCode').errors?.required &&
                        formSubmitted
                      "
                      matTooltip="{{ formErrors.postCode }}"
                      matTooltipPosition="above"
                    >
                      <option [value]="null">Select</option>
                      <option
                        *ngFor="let city of locationPostCodeList[i]"
                        [ngValue]="city"
                      >
                        {{ city.name }}
                      </option>
                    </select>

                    <div
                      *ngIf="
                        formStatus == 'edit' && !locationPostCodeListEnable[i]
                      "
                      (click)="
                        enableLocationPostCode(location.get('city').value, i)
                      "
                      matTooltip="Click To Change"
                      matTooltipPosition="above"
                      style="cursor: pointer"
                    >
                      <span *ngIf="location.get('postCode').value">{{
                        location.get("postCode").value.name
                      }}</span>
                    </div>

                    <select
                      *ngIf="
                        formStatus == 'edit' && locationPostCodeListEnable[i]
                      "
                      class="form-control form-control-xs"
                      [id]="'postCode_' + i"
                      [name]="'postCode_' + i"
                      type="text"
                      class="form-control form-control-xs"
                      formControlName="postCode"
                      [class.is-invalid]="
                        location.get('postCode').errors?.required &&
                        formSubmitted
                      "
                      matTooltip="{{ formErrors.postCode }}"
                      matTooltipPosition="above"
                    >
                      <option [value]="null">Select</option>
                      <option
                        *ngFor="let city of locationPostCodeList[i]"
                        [ngValue]="city"
                      >
                        {{ city.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group mb-0">
                    <label class="mb-0">Distance :</label>
                    <input
                      [id]="'distance_' + i"
                      [name]="'distance_' + i"
                      type="text"
                      class="form-control form-control-xs"
                      formControlName="distance"
                      [class.is-invalid]="
                        location.get('distance').errors?.required &&
                        formSubmitted
                      "
                      matTooltip="{{ formErrors.distance }}"
                      matTooltipPosition="above"
                    />
                  </div>
                </div>
                <div class="col-md-1">
                  <button
                    type="button"
                    *ngIf="!first"
                    class="btn btn-sm btn-outline-danger mt-3"
                    (click)="removeClientLocationButtonClick(i)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row col-md-12">
        <div class="col-md-4"> </div>
        <div class="col-md-4"> </div>
        <div class="col-md-4"> </div>
      </div> -->
        <!--  -->
        <div id="checklistDiv" *ngIf="showChecklist">
          <div class="container border">
            <div class="row col-md-12 m-0 p-0">
              <div class="row col-md-12 m-0 p-0 border">
                <div class="row col-md-12">
                  <div class="col-md-12 p-2">
                    <h6 style="font-weight: bold; text-align: center">
                      P G BHAGWAT LLP
                    </h6>
                    <h6 style="font-weight: bold; text-align: center">
                      Client Acceptance Checklist
                    </h6>
                  </div>
                </div>
                <div class="row col-md-12">
                  <div class="col-md-2" style="font-weight: bold">
                    Name of the Client :
                  </div>
                  <div class="col-md-5" style="color: red">
                    {{ formObj.get("name").value }}
                  </div>
                </div>
                <div class="row col-md-12">
                  <div class="col-md-2" style="font-weight: bold">
                    Legal Status :
                  </div>
                  <div class="col-md-5" style="color: red">
                    {{ formObj.get("legalStatus").value.name }}
                  </div>
                </div>
                <div class="row col-md-12">
                  <div class="col-md-2" style="font-weight: bold">
                    Partners :
                  </div>
                  <div class="col-md-10" style="color: red">
                    <span
                      *ngFor="
                        let partner of assignedPartnerList;
                        let i = index;
                        let first = first;
                        let last = last
                      "
                    >
                      {{ partnerList[findIndexForPartner(partner)].firstName }}
                      {{ partnerList[findIndexForPartner(partner)].lastName }}
                      <span *ngIf="i < assignedPartnerList.length && !last">
                        ,
                      </span>
                      <span *ngIf="last"> . </span>
                    </span>
                  </div>
                </div>
                <div class="row col-md-12">
                  <div class="col-md-2" style="font-weight: bold">
                    Assignments :
                  </div>
                  <div class="col-md-10" style="color: red">
                    <span
                      *ngFor="
                        let assignment of checkListAssignments;
                        let i2 = index;
                        let first = first;
                        let last = last
                      "
                    >
                      {{ assignment.name }}
                      <span *ngIf="i2 < checkListAssignments.length && !last">
                        ,
                      </span>
                      <span *ngIf="last"> . </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row col-md-12 m-0 p-0">
              <div class="row col-md-12 m-0 p-0 border">
                <div
                  class="col-md-1 right-border"
                  style="max-width: 5%; font-weight: bold; padding: 0px"
                >
                  Sr.No
                </div>
                <div class="col-md-7 right-border" style="font-weight: bold">
                  Identification of Risk / Problem Areas
                </div>
                <div class="col-md-1 right-border" style="font-weight: bold">
                  Yes/No
                </div>
                <div class="col-md-3" style="font-weight: bold">Remark</div>
              </div>
            </div>
            <!-- style="height:350px;display: block;overflow-y: scroll;" -->

            <div class="row col-md-12 m-0 p-0">
              <div
                class="row col-md-12 m-0 p-0"
                formArrayName="clientCheckList"
                *ngFor="
                  let checklist of formObj.get('clientCheckList').controls;
                  let i = index
                "
              >
                <div class="row col-md-12 m-0 p-0 border" [formGroupName]="i">
                  <div
                    class="col-md-1 right-border"
                    style="
                      max-width: 5%;
                      text-align: center;
                      font-weight: bold;
                      padding: 0px;
                    "
                  >
                    {{ i + 1 }}
                  </div>
                  <div
                    class="col-md-7 right-border"
                    style="font-size: smaller; word-break: break-all"
                  >
                    {{ checklist.value.question }}
                  </div>
                  <div class="col-md-1 right-border">
                    <input
                      type="checkbox"
                      id="isRequired_{{ i }}"
                      name="isRequired_{{ i }}"
                      class=""
                      formControlName="isRequired"
                    />
                  </div>
                  <div class="col-md-3">
                    <input
                      type="text"
                      id="remark_{{ i }}"
                      name="remark_{{ i }}"
                      class="form-control form-control-xs"
                      formControlName="remark"
                      [class.is-invalid]="
                        checklist.get('remark').errors?.required &&
                        formSubmitted
                      "
                      matTooltip="{{ formErrors.remark }}"
                      matTooltipPosition="above"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row col-md-12 m-0 p-0">
              <div class="row col-md-12 m-0 p-0 border">
                <div class="row col-md-12">
                  <div class="col-md-12">
                    <h6 style="font-weight: bold">OVERALL CONCLUSION:</h6>
                  </div>
                </div>
                <div class="row col-md-12">
                  <div class="col-md-12">
                    Based on the comments as noted above, we conclude that the
                    engagement can be accepted
                  </div>
                </div>
                <div class="row col-md-12">
                  <div class="col-md-2" style="font-weight: bold">Sign :</div>
                  <div class="col-md-5">
                    <input
                      type="checkbox"
                      id="isSign"
                      name="isSign"
                      class="mt-2"
                      formControlName="isSign"
                    />
                  </div>
                </div>
                <div class="row col-md-12">
                  <div class="col-md-2" style="font-weight: bold">Date :</div>
                  <div class="col-md-5" style="color: red">
                    {{ formObj.get("signDate").value | date: "dd-MM-yyyy" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="clientBudgetDiv" *ngIf="showClientBudget">
          <div class="row mb-3">
            <div class="col-md-12" style="text-align: center">
              <span class="bg-theme-title">Client Budget</span>
            </div>
          </div>
          <div class="container border">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Financial Year:</label>
                  <select
                    class="form-control form-control-xs"
                    type="text"
                    class="form-control form-control-xs"
                    formControlName="financialYear"
                    (change)="onChangeFinancialYear()"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                  >
                    <option [value]="null">Select</option>
                    <option
                      *ngFor="let fy of budgetFinancialYearList"
                      [ngValue]="fy"
                    >
                      {{ fy.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Partner Assigned:</label>
                  <select
                    class="form-control form-control-xs"
                    [id]="'assignedPartner'"
                    [name]="'assignedPartner'"
                    type="text"
                    class="form-control form-control-xs"
                    (change)="loadAssignmentList()"
                    formControlName="assignedPartner"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                  >
                    <option [value]="null">Select</option>
                    <option
                      *ngFor="let partner of clientBudgetPartnerList"
                      [ngValue]="partner"
                    >
                      {{ partner.firstName }} {{ partner.middleName }}
                      {{ partner.lastName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Assignment:</label>
                  <select
                    class="form-control form-control-xs"
                    [id]="'assignment'"
                    [name]="'assignment'"
                    type="text"
                    class="form-control form-control-xs"
                    (change)="checkIfBudgetExist()"
                    formControlName="assignment"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                  >
                    <option [value]="null">Select</option>
                    <option
                      *ngFor="let assignment of clientBudgetAssignmentList"
                      [ngValue]="assignment"
                    >
                      {{ assignment.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Assignment Fees:</label>
                  <input
                    class="form-control form-control-xs"
                    type="text"
                    name="assignmentFees"
                    id="assignmentFees"
                    formControlName="assignmentFees"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                    (blur)="assignmentFeesValue()"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Role:</label>
                  <select
                    class="form-control form-control-xs"
                    [id]="'role'"
                    [name]="'role'"
                    [compareWith]="compareById"
                    type="text"
                    class="form-control form-control-xs"
                    formControlName="role"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                  >
                    <option [ngValue]="null">Select</option>
                    <option *ngFor="let role of roleList" [ngValue]="role">
                      {{ role.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Service Vertical:</label>
                  <select
                    class="form-control form-control-xs"
                    [id]="'serviceVertical'"
                    [name]="'serviceVertical'"
                    [compareWith]="compareById"
                    type="text"
                    (change)="loadEmployeesForServiceVerticalAndRoles()"
                    class="form-control form-control-xs"
                    formControlName="serviceVertical"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                  >
                    <option [ngValue]="null">Select</option>
                    <option *ngFor="let serviceVertical of serviceVerticalList" [ngValue]="serviceVertical">
                      {{ serviceVertical.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Employee:</label>
                  <select
                    class="form-control form-control-xs"
                    [id]="'employee'"
                    [name]="'employee'"
                    type="text"
                    class="form-control form-control-xs"
                    formControlName="employee"
                    matTooltipPosition="above"
                    matTooltipClass="warn-tooltip"
                  >
                    <option [value]="null">Select</option>
                    <option
                      *ngFor="let employee of employeeList"
                      [ngValue]="employee"
                    >
                      {{ employee.firstName }} {{ employee.middleName }}
                      {{ employee.lastName }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <button
                  type="button"
                  class="btn btn-xs btn-theme mt-4"
                  (click)="addBudgetBtnClick()"
                >
                  <i class="fa fa-plus-square-o" aria-hidden="true"></i> ADD
                </button>
              </div>
            </div>
            <!-- [disabled]="budgetForm.invalid" -->
            <br />

            <div class="" *ngIf="formObj.get('budgetDetails').value.length > 0">
              <table width="100%">
                <tbody>
                  <tr>
                    <td colspan="10" style="border: none; padding: 0px">
                      <table width="100%" class="bg-lightgray">
                        <tr>
                          <th style="width: 10%">Role</th>
                          <th style="width: 15%">Service Vertical</th>
                          <th style="width: 15%">Employee</th>
                          <!-- <th style="width: 15%">Assigned Partner</th> -->
                          <th style="width: 15%">Assignment</th>
                          <th style="width: 7%">Financial Year</th>
                          <th style="width: 10%">Standard Rate</th>
                          <th style="width: 5%">Man Days</th>
                          <th style="width: 5%">Count</th>
                          <th style="width: 5%; text-align: right">
                            Total Man Days
                          </th>
                          <th style="width: 5%; text-align: right">Cost</th>
                          <th style="width: 3%"></th>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="10" style="border: none; padding: 0px">
                      <table
                        width="100%"
                        formArrayName="budgetDetails"
                        *ngFor="
                          let budgetDetail of formObj.get('budgetDetails')
                            .controls;
                          let i = index;
                          let first = first
                        "
                      >
                        <tr [formGroupName]="i">
                          <td style="width: 10%">
                            {{ budgetDetail.value.role.name }}
                          </td>
                          <td style="width: 10%">
                            {{ budgetDetail.value.serviceVertical?.name }}
                          </td>
                          <td style="width: 15%">
                            {{ budgetDetail.value.user.firstName }}
                            {{ budgetDetail.value.user.middleName }}
                            {{ budgetDetail.value.user.lastName }}
                          </td>
                          <!-- <td style="width: 15%">
                            {{ budgetDetail.value.partner.firstName }}
                            {{ budgetDetail.value.partner.middleName }}
                            {{ budgetDetail.value.partner.lastName }}
                          </td> -->
                          <td style="width: 15%">
                            {{ budgetDetail.value.assignment.name }}
                          </td>
                          <td style="width: 7%">
                            {{ budgetDetail.value.financialYear.name }}
                          </td>
                          <td style="width: 10%">
                            {{ budgetDetail.value.standardRate }}
                          </td>
                          <td style="width: 5%">
                            <input
                              [id]="'budgetedDays_' + i"
                              [name]="'budgetedDays_' + i"
                              (blur)="clickOnManyDay(budgetDetail, i)"
                              type="number"
                              class="form-control form-control-xs"
                              style="text-align: right"
                              formControlName="budgetedDays"
                              matTooltipPosition="above"
                              min="0"
                            />
                          </td>
                          <td
                            style="width: 5%"
                            *ngIf="budgetDetail.value.role.name == 'Article'"
                          >
                            <input
                              [id]="'count_' + i"
                              [name]="'count_' + i"
                              type="number"
                              class="form-control form-control-xs"
                              style="text-align: right"
                              formControlName="count"
                              matTooltipPosition="above"
                              min="1"
                              (blur)="
                                onCountChange(
                                  budgetDetail.value.budgetedDays,
                                  i
                                )
                              "
                            />
                          </td>
                          <td
                            style="width: 5%; text-align: end"
                            *ngIf="budgetDetail.value.role.name != 'Article'"
                          >
                            {{ budgetDetail.value.count }}
                          </td>
                          <td style="width: 5%; text-align: right">
                            {{
                              budgetDetail.value.budgetedDays *
                                budgetDetail.value.count
                            }}
                          </td>
                          <td style="width: 5%; text-align: right">
                            {{
                              budgetDetail.value.standardRate *
                                budgetDetail.value.count *
                                budgetDetail.value.budgetedDays
                            }}
                          </td>

                          <td style="width: 3%; text-align: right">
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-danger"
                              (click)="removeBudget(i)"
                            >
                              <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="10" style="border: none; padding: 0px">
                      <table width="100%">
                        <tr>
                          <th style="width: 10%">Total</th>
                          <th style="width: 15%"></th>
                          <th style="width: 15%"></th>
                          <th style="width: 15%"></th>
                          <th style="width: 7%"></th>
                          <th style="width: 10%"></th>
                          <th style="width: 5%"></th>
                          <th style="width: 5%"></th>
                          <th style="width: 5%"></th>
                          <th style="width: 5%">
                            {{ getTotalCost() }}
                          </th>
                          <th style="width: 3%"></th>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </form>
      <!-- </mat-card> -->
    </div>
  </div>

  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="closeModal(formStatus, 'error')"
        >
          Close
        </button>
      </div>
      <div class="col-sm-2">
        <button
          type="button"
          [disabled]="
            !(
              (formStatus == 'add' || formStatus == 'edit') &&
              (showChecklist || showClientBudget)
            )
          "
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="onBackBtnClick()"
        >
          <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      <div class="col-sm-2">
        <!--

        -->
        <button
          type="button"
          *ngIf="
            (formStatus == 'add' || formStatus == 'edit') && showNextButton
          "
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onNextBtnClick()"
        >
          Next <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          *ngIf="formStatus == 'add' && !showNextButton"
          class="btn btn-sm btn-block btn-outline-theme"
          [disabled]="formObj.invalid"
          (click)="onSaveClick()"
        >
          Save
        </button>
        <button
          type="button"
          *ngIf="formStatus == 'edit' && !showNextButton"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onUpdateClick()"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
